var map = {
	"./SpinTorre2_072.webp": 58738,
	"./spinTorre2_001.webp": 31377,
	"./spinTorre2_002.webp": 34675,
	"./spinTorre2_003.webp": 8324,
	"./spinTorre2_004.webp": 90273,
	"./spinTorre2_005.webp": 38456,
	"./spinTorre2_006.webp": 86383,
	"./spinTorre2_007.webp": 39735,
	"./spinTorre2_008.webp": 66966,
	"./spinTorre2_009.webp": 87963,
	"./spinTorre2_010.webp": 91826,
	"./spinTorre2_011.webp": 76864,
	"./spinTorre2_012.webp": 37113,
	"./spinTorre2_013.webp": 41578,
	"./spinTorre2_014.webp": 96796,
	"./spinTorre2_015.webp": 60303,
	"./spinTorre2_016.webp": 3864,
	"./spinTorre2_017.webp": 51491,
	"./spinTorre2_018.webp": 96868,
	"./spinTorre2_019.webp": 72688,
	"./spinTorre2_020.webp": 92558,
	"./spinTorre2_021.webp": 40470,
	"./spinTorre2_022.webp": 7445,
	"./spinTorre2_023.webp": 14818,
	"./spinTorre2_024.webp": 38630,
	"./spinTorre2_025.webp": 52512,
	"./spinTorre2_026.webp": 47647,
	"./spinTorre2_027.webp": 76674,
	"./spinTorre2_028.webp": 4562,
	"./spinTorre2_029.webp": 44017,
	"./spinTorre2_030.webp": 58506,
	"./spinTorre2_031.webp": 12492,
	"./spinTorre2_032.webp": 853,
	"./spinTorre2_033.webp": 56920,
	"./spinTorre2_034.webp": 90596,
	"./spinTorre2_035.webp": 50920,
	"./spinTorre2_036.webp": 43713,
	"./spinTorre2_037.webp": 98877,
	"./spinTorre2_038.webp": 4426,
	"./spinTorre2_039.webp": 12600,
	"./spinTorre2_040.webp": 95851,
	"./spinTorre2_041.webp": 61937,
	"./spinTorre2_042.webp": 24378,
	"./spinTorre2_043.webp": 90183,
	"./spinTorre2_044.webp": 85931,
	"./spinTorre2_045.webp": 2571,
	"./spinTorre2_046.webp": 47762,
	"./spinTorre2_047.webp": 57408,
	"./spinTorre2_048.webp": 85273,
	"./spinTorre2_049.webp": 6501,
	"./spinTorre2_050.webp": 18321,
	"./spinTorre2_051.webp": 17103,
	"./spinTorre2_052.webp": 54210,
	"./spinTorre2_053.webp": 95083,
	"./spinTorre2_054.webp": 19061,
	"./spinTorre2_055.webp": 55986,
	"./spinTorre2_056.webp": 3926,
	"./spinTorre2_057.webp": 12991,
	"./spinTorre2_058.webp": 82769,
	"./spinTorre2_059.webp": 43294,
	"./spinTorre2_060.webp": 94096,
	"./spinTorre2_061.webp": 77629,
	"./spinTorre2_062.webp": 5427,
	"./spinTorre2_063.webp": 17984,
	"./spinTorre2_064.webp": 58107,
	"./spinTorre2_065.webp": 13220,
	"./spinTorre2_066.webp": 63389,
	"./spinTorre2_067.webp": 55535,
	"./spinTorre2_068.webp": 9590,
	"./spinTorre2_069.webp": 25500,
	"./spinTorre2_070.webp": 72188,
	"./spinTorre2_071.webp": 51206
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70515;